<script>
export default {
    data() {
        return {
            isActive: false,
            vConfig: {
                handler: this.clickOutsideHandler,
                middleware: this.clickOutsideMiddleware
            }
        };
    },
    methods: {
        clickOutsideHandler(e) {
            this.isActive = false;
        },

        clickOutsideMiddleware(event) {
            return event.target !== this.$refs.toggle;
        }
    }
};
</script>
